import axios from "axios";
import {
  globalUrl,
  apiUrl,
  robnoUrl,
  changePassUrl,
  productUrl,
} from "../Config/Url";

export const globalServices = {
  getTenants,
  getStoresByTenantId,
  getLanguages,
  getResourcesByLanguageId,
  getCountries,
  getItemGroups,
  getUnitOfMeasures,
  getTaxRates,
  getPriceLists,
  getPriceListStores,
  getPostOffices,
  getCityByPostOffice,
  getPartnersByTenantId,
  getWidgetsPerformance,
  getWidgetsStatistics,
  getActiveWidgetsPerf,
  getAllWidgetsStat,
  putWidgets,
  Overview,
  getProvisionTypes,
  getPosLogReasons,
  getTenantsForDd,
  getFilterProducts,
  getTenantsRobno,
  changePassword,
  getProductGroupsByTenantId,
  getDocumentTypesByTenantId,
  getFilterInventoryProducts,
  getProductsByNormativeType,
};

async function putWidgets() {
  return axios
    .put(`${apiUrl}/Widget`)
    .then((res) => res)
    .catch((err) => err.response);
}
async function getProductsByNormativeType(storeId, normativeType) {
  return axios
    .get(
      `${productUrl}/normative?storeId=${storeId}&normativeType=${normativeType}`
    )
    .then((res) => res)
    .catch((err) => err.response);
}
async function Overview(storeId, posId) {
  return axios
    .put(`${apiUrl}/Overview`, { storeId, posId })
    .then((res) => res)
    .catch((err) => err.response);
}

async function getWidgetsPerformance() {
  return axios
    .get(`${apiUrl}/Widget/performance`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getWidgetsStatistics() {
  return axios
    .get(`${apiUrl}/Widget/statistics`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getActiveWidgetsPerf() {
  return axios
    .get(`${apiUrl}/Widget/activePerformance`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getAllWidgetsStat() {
  return axios
    .get(`${apiUrl}/Widget/statistics`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getTenants(userId, searchText, locTenant) {
  if (userId) {
    return axios
      .get(
        `${globalUrl}/tenants?userId=${userId}&searchText=${searchText}&tenantId=${
          locTenant ? locTenant : 0
        }`
      )
      .then((res) => res)
      .catch((err) => err.response);
  } else {
    return axios
      .get(
        `${globalUrl}/tenants?searchText=${searchText}&tenantId=${
          locTenant ? locTenant : 0
        }`
      )
      .then((res) => res)
      .catch((err) => err.response);
  }
}

async function getStoresByTenantId(tenantId) {
  let url;
  tenantId
    ? (url = `${globalUrl}/stores?tenantId=${tenantId}`)
    : (url = `${globalUrl}/stores`);
  return axios
    .get(`${url}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getLanguages() {
  return axios
    .get(`${globalUrl}/languages`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getResourcesByLanguageId(languageId) {
  return axios
    .get(`${globalUrl}/resources?languageId=${languageId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getCountries() {
  return axios
    .get(`${globalUrl}/countries`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getItemGroups(tenantId) {
  return axios
    .get(`${globalUrl}/item-groups?tenantId=${tenantId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getUnitOfMeasures(tenantId) {
  return axios
    .get(`${globalUrl}/unit-of-measures`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getTaxRates(tenantId) {
  return axios
    .get(`${globalUrl}/tax-rates`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPriceLists(tenantId) {
  return axios
    .get(`${globalUrl}/pricelist/${tenantId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPriceListStores(storeId) {
  return axios
    .get(`${globalUrl}/priceliststores/${storeId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPostOffices() {
  return axios
    .get(`${globalUrl}/post-offices`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getCityByPostOffice(postOfficeId) {
  return axios
    .get(`${apiUrl}/City/${postOfficeId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPartnersByTenantId(tenantId) {
  return axios
    .get(`${globalUrl}/partners/${tenantId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getProvisionTypes() {
  return axios
    .get(`${globalUrl}/provision-types`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPosLogReasons() {
  return axios
    .get(`${globalUrl}/posLogReasons`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getTenantsForDd(userId) {
  return axios
    .get(
      `${globalUrl}/tenants?userId=${userId}&owner=true&searchText=${""}&tenantId=${0}`
    )
    .then((res) => {
      return res;
    })
    .catch((err) => err.response);
}

async function getFilterProducts(storeId, documentOption) {
  return axios
    .get(
      `${robnoUrl}/Product/store?storeId=${storeId}&documentOption=${documentOption}`
    )
    .then((res) => res)
    .catch((err) => err.response);
}
async function getFilterInventoryProducts(storeId, documentOption, year) {
  console.log(year);
  return axios
    .get(
      `${robnoUrl}/Product/store?storeId=${storeId}&documentOption=${documentOption}&year=${year}`
    )
    .then((res) => res)
    .catch((err) => err.response);
}

async function getTenantsRobno(userId, searchText, locTenant) {
  if (userId) {
    return axios
      .get(
        `${robnoUrl}/global/tenants?userId=${userId}&searchText=${searchText}&tenantId=${
          locTenant ? locTenant : 0
        }`
      )
      .then((res) => res)
      .catch((err) => err.response);
  } else {
    return axios
      .get(
        `${robnoUrl}/global/tenants?searchText=${searchText}&tenantId=${
          locTenant ? locTenant : 0
        }`
      )
      .then((res) => res)
      .catch((err) => err.response);
  }
}

async function changePassword(data) {
  return axios
    .post(changePassUrl, data)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getProductGroupsByTenantId(tenantId) {
  return axios
    .get(`${robnoUrl}/Global/product-groups?tenantId=${tenantId}`)
    .then((res) => res)
    .catch((err) => err);
}
async function getDocumentTypesByTenantId(tenantId) {
  return axios
    .get(`${robnoUrl}/Global/document-types?tenantId=${tenantId}`)
    .then((res) => res)
    .catch((err) => err);
}
